import { render } from 'preact';
import { App } from './app';
import './styles.css';

const container = document.getElementById('app');
if (container === null) throw new Error('Missing #app container');

document.documentElement.lang = document.documentElement.lang || 'ru';
render(<App />, container);
